<div *ngIf="!editando" [class.inline-edit-preview]="modoEditar" (click)="activarEdicion()">
  <ng-content></ng-content>
</div>

<div *ngIf="editando" [ngSwitch]="type" class="inline-edit-form">
 
  <input *ngSwitchCase="'text'"
         type="text"
         [class]="inputClass"
         [(ngModel)]="valorTemporal"
         [placeholder]="placeholder"
         (blur)="guardarCambios()"
         (keyup.enter)="guardarCambios()"
         appAutofocus>

  <textarea *ngSwitchCase="'textarea'"
            [class]="inputClass"
            [(ngModel)]="valorTemporal"
            [placeholder]="placeholder"
            (blur)="guardarCambios()"
            (keyup.enter)="guardarCambios()"
            rows="3"
            appAutofocus></textarea>

  <input *ngSwitchCase="'date'"
         type="date"
         [class]="inputClass"
         [(ngModel)]="valorTemporal"
         (blur)="guardarCambios()"
         (keyup.enter)="guardarCambios()"
         appAutofocus>

  <div *ngSwitchCase="'switch'" class="form-check form-switch mt-1">
    <input class="form-check-input" 
          type="checkbox" 
          role="switch"
          [class]="inputClass"
          [(ngModel)]="valorTemporal"
          (change)="guardarCambios()">
  </div>

  <ng-select *ngSwitchCase="'ngselect'"
            class="auto-width"
            [ngClass]="inputClass"
            [items]="options" 
            [bindLabel]="options[0]?.label !== undefined ? 'label' : ''" 
            [bindValue]="options[0]?.value !== undefined ? 'value' : ''"
            name="mt_tipo"
            notFoundText="Tipo no encontrado"
            [placeholder]="valorTemporal ? '' : 'Escribe para buscar...'"
            [(ngModel)]="valorTemporal"
            (change)="guardarCambios()"
            (blur)="guardarCambios()"
            appAutofocus>
  </ng-select>

  <select *ngSwitchCase="'select'"
          [ngClass]="inputClass"
          [(ngModel)]="valorTemporal"
          (blur)="guardarCambios()"
          (change)="guardarCambios()"
          appAutofocus>
    <option *ngIf="placeholder" [value]="''" disabled>{{ placeholder }}</option>
    
    <ng-container *ngFor="let opt of options">
      <option [value]="opt.value !== undefined ? opt.value : opt">
        {{ opt.label !== undefined ? opt.label : opt }}
      </option>
    </ng-container>
  </select>

</div>